import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetIncomingPostbackLogsResponse = App.Http.Responses.IncomingPostbackLog.GetIncomingPostbackLogsResponse;
import GetIncomingPostbackLogResponse = App.Http.Responses.IncomingPostbackLog.GetIncomingPostbackLogResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class IncomingPostbackLogApi extends TenantBaseApi {
    async index(request: {
        filter?: App.Http.Requests.FilterRequest;
        page?: App.Http.Requests.PageRequest;
    }): Promise<GetIncomingPostbackLogsResponse> {
        return await this.get<GetIncomingPostbackLogsResponse, typeof request>("/incoming-postback-logs", {
            params: request,
        });
    }

    async show(
        logId: string,
        request: {
            filter?: App.Http.Requests.FilterRequest;
        }
    ): Promise<GetIncomingPostbackLogResponse> {
        return await this.get<GetIncomingPostbackLogResponse, typeof request>(`/incoming-postback-logs/${logId}`, {
            params: request,
        });
    }

    async export(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/incoming-postback-logs/export`, request);
    }
}

export const incomingPostbackLogApi = new IncomingPostbackLogApi();
